export enum StatisticInterval {
  NONE = 'NONE',
  HOUR = 'HOUR',
  DAY = 'DAY',
  WEEK = 'WEEK',
  TWO_WEEKS = 'TWO_WEEKS',
  MONTH = 'MONTH',
  QUARTER = 'QUARTER',
  HALF_YEAR = 'HALF_YEAR',
  YEAR = 'YEAR',
}

export interface StatisticPeriod {
  from: Date;
  to: Date;
  interval: StatisticInterval;
}

export interface Statistic {
  sectionMetrics(period: StatisticPeriod): [SectionMetric];
}

export interface SectionMetric {
  key: string;
  course_id: string;
  lesson_type: string;
  lesson_id: string;
  mode: string;
  section_id: string;
  level: string;
  duration_avg: string;
  app_pause_avg: string;
  app_resume_avg: string;
  lesson_quit_avg: string;
  section_start: number;
  section_complete_rate: string;
  level_start: number;
  level_pass_rate: string;
  level_fail_rate: string;
  question_start: number;
  question_pass_rate: string;
  question_fail_rate: string;
  operation_start: number;
  operation_end: number;
  operation_correct_avg: string;
  operation_wrong_avg: string;
  operation_wrong_longest_avg: string;
  operation_wrong_longest_med: string;
  operation_neutral_avg: string;
  operation_timeout_avg: string;
  ui_next_appear: number;
  ui_next_click_rate: string;
  from: number;
  to: number;
}



// WEBPACK FOOTER //
// ./src/screens/statistic/type.tsx